$(document).ready(function () {
    if($('.halloween-banner-list .halloween-banner_box').length > 1){  
      $('.halloween-banner-list').slick({
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 1,
          adaptiveHeight: true
      });    
    }

    $('.announcement-halloween__content').slick({
        arrows: true,
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
    });

});

